import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import { occasionOption } from "Apis/occasion";

export const AmenityContext = createContext();

export const AmenityContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [formIsEdit, setFormIsEdit] = useState(false);
  const [editData, setEditData] = useState([]);
  const [occasionList, setOccasionList] = useState([]);

  const getAllOccasions = async () => {
    const data = {
      is_admin: true,
    };
    let response = await occasionOption(data);
    if (response?.status === 200) {
      const formatted = response.data.data.rows?.map((item) => ({
        id: parseInt(item?.id),
        label: item?.name,
      }));
      setOccasionList(formatted);
      return formatted; // ← return so form can use it immediately on mount
    }
    return [];
  };
  const handleOpenModal = () => {
    setOpen(true);
    setFormIsEdit(false);
  };

  return (
    <AmenityContext.Provider
      value={{
        open,
        setOpen,
        formIsEdit,
        setFormIsEdit,
        handleOpenModal,
        editData,
        setEditData,
        occasionList,
        getAllOccasions,
      }}
    >
      {children}
    </AmenityContext.Provider>
  );
};

export default AmenityContextProvider;
AmenityContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
